/**
 * Route guard wrapping top-level routes in App.tsx, using UserContext auth
 * state. requiresAdmin renders the component only for admins (else redirects
 * to /bounties); requiresLogin renders it only when logged in (else redirects
 * to /signUpLogin); with requiresLogin false the route is logged-out-only and
 * logged-in users are redirected to /bounties (e.g. the signUpLogin page).
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useUserState } from "@/contexts/UserContext";

interface ProtectedRouteProps {
    component: React.ComponentType<any>;
    requiresLogin: boolean; // if false this can't be accessed by logged in users
    requiresAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    component: Component,
    requiresLogin,
    requiresAdmin,
}) => {
    const user = useUserState();

    if (requiresAdmin) {
        return user?.isAdmin ? <Component /> : <Navigate to="/bounties" />;
    }
    if (requiresLogin) {
        return user ? <Component /> : <Navigate to="/signUpLogin" />;
    }

    return user ? <Navigate to="/bounties" /> : <Component />;
};

export default ProtectedRoute;
